import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const uploadResultXlsx = async ({ periodId, files }) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const formData = new FormData()
  Array.from(files).forEach(file => formData.append('files', file))
  const { data } = await client.post(
    `/current-organization/course-assignment/periods/${periodId}/results/xlsx`,
    formData
  )
  return data
}

export const useUploadResultXlsx = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: uploadResultXlsx,
    hookName: 'useUploadResultXlsx',
    errorMessage: 'Error uploading course assignment result (xlsx)',
    shouldReportError: (error) => error?.response?.status !== 400,
    onSuccess: (_data, { periodId }) => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentResultVersions', periodId] })
    }
  })
}
